import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import DeviceInfo from 'react-native-device-info';
import ForceUpdateScreen from './ForceUpdateScreen';
import ReactNativeBlobUtil from 'react-native-blob-util';
import {Platform} from 'react-native';
import {isSkipUpdate, setSkip} from '../utils/commonMethods';

const ForceUpdate = props => {
  // state variable holds the state of the internet connection

  const [appversion, setappversion] = useState();
  const [updateApp, setUpdateApp] = useState(false);

  //   let globalConfigData = useSelector(
  //     ({ utilCommonData }) => utilCommonData.globalConfigData
  //   );

  let globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  useEffect(() => {
    if (globalConfigData?.minBuildNumber) {
      //   navigator.splashscreen.hide();
    }
  }, [globalConfigData?.minBuildNumber]);

  useEffect(() => {
    if (Platform.OS === 'ios') {
      let buildNumber = DeviceInfo.getVersion();
      setappversion(+buildNumber.split('.').join(''));
    } else {
      let buildNumber = DeviceInfo.getBuildNumber();
      setappversion(buildNumber);
    }
  }, []);

  useEffect(() => {
    if (Platform.OS === 'android') {
      const filePath =
        ReactNativeBlobUtil.fs.dirs.DownloadDir + 'TradexApp' + '.apk';
      ReactNativeBlobUtil.fs
        .unlink(filePath)
        .then(() => {
          //update();
        })
        .catch(err => {
          // update();
          //console.log('err', err);
        });
    }
  }, []);

  const notNow = function () {
    setSkip('Skipped');
    //AsyncStorage.setItem('updateSkipped', 'Skipped');
    setUpdateApp(false);
  };

  const hasLatestUpdate = async () => {
    var item = isSkipUpdate?.isSkip;
    if (item === 'Skipped') {
      setUpdateApp(false);
    } else {
      if (appversion < globalConfigData?.minBuildNumber) {
        setUpdateApp(true);
      } else {
        setUpdateApp(false);
      }
    }
  };

  useEffect(() => {
    if (globalConfigData && appversion) {
      hasLatestUpdate();
    }
  }, [globalConfigData, appversion]);

  // if app is updated, return the child component else return a custom component
  if (!updateApp) {
    return props.children;
  } else {
    return <ForceUpdateScreen notNow={() => notNow()} />;
  }
};

export default ForceUpdate;
